<template>
    <div style="width:350px"  v-loading="fullscreenLoading">           
        <el-form autocomplete="off" size="mini" :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
          <el-row>
            <el-col :span="20">
            <el-form-item label="原密码" prop="age" >
                <el-input type="password" v-model="ruleForm2.age" clearable></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="pass" >
                <el-input type="password" v-model="ruleForm2.pass" clearable auto-complete="off" maxlength="20" placeholder="8-20位,支持数字和字母"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass" >
                <el-input type="password" v-model="ruleForm2.checkPass" clearable auto-complete="off" maxlength="20" placeholder="8-20位,支持数字和字母"></el-input>
            </el-form-item>
            </el-col>
          </el-row>      
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm2')">提交</el-button>
                <el-button @click="resetForm('ruleForm2')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        callback(new Error("原密码不能为空"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      let rez = /^(?![^A-z]+$)(?!\D+$)[A-z\d]{8,20}$/;
      // let rez = /^[0-9a-zA-Z]{8,20}$/;
      if (!rez.test(value)) {
        return callback(new Error("8-20位,支持数字和字母"));
      }
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
      let rez = /^(?![^A-z]+$)(?!\D+$)[A-z\d]{8,20}$/;
      // let rez = /^[0-9a-zA-Z]{8,20}$/;
      if (!rez.test(value)) {
        return callback(new Error("8-20位,支持数字和字母"));
      }
    };
    return {
      fullscreenLoading: false,
      ruleForm2: {
        pass: "",
        checkPass: "",
        age: ""
      },
      rules2: {
        pass: [
          { validator: validatePass, trigger: "blur" },
          { min: 8, max: 20, message: "8-20位,支持数字和字母", trigger: "blur" }
        ],
        checkPass: [
          { validator: validatePass2, trigger: "blur" },
          { min: 8, max: 20, message: "8-20位,支持数字和字母", trigger: "blur" }
        ],
        age: [{ validator: checkAge, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.fullscreenLoading = true;
          if (this.ruleForm2.age == this.ruleForm2.pass) {
            this.$message({
              showClose: true,
              message: "原密码不能和新密码一致",
              type: "error"
            });
          }
          let data = {
            oldPwd: this.ruleForm2.age,
            newPwd: this.ruleForm2.pass,
            newConfirmPwd: this.ruleForm2.checkPass
          };
          this.$http.post("/w/user/modifyPwd", data).then(
            data => {
              this.$message.success("修改密码成功");
              this.$http.post("/w/user/logout").then(() => {
                localStorage.setItem("tokenId", "");
                this.$router.push("/login");
              });
              this.$refs["ruleForm2"].resetFields();
              this.fullscreenLoading = false;
            },
            () => {
              this.fullscreenLoading = false;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/page/editPw/editPw.vue